import { render, staticRenderFns } from "./ScreeningProgressInsightsTab.vue?vue&type=template&id=1e1a9da6&scoped=true&"
import script from "./ScreeningProgressInsightsTab.vue?vue&type=script&lang=js&"
export * from "./ScreeningProgressInsightsTab.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningProgressInsightsTab.vue?vue&type=style&index=0&id=1e1a9da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1a9da6",
  null
  
)

export default component.exports